module.exports = __webpack_public_path__ + "static/img/vuetify.1c24330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skills/vuetify.png
// module id = 527
// module chunks = 1